<template>
  <div class="home">
    <!--        新闻资讯-->
    <div class="news ">
      <el-carousel height="664px" arrow="never" :interval="6000">
        <el-carousel-item v-for="(item,index) in newsBanner" :key="index">
          <div class="newsBanner" :style="'backgroundImage: url('+item.imgPath+')'">
            <a v-if="item.imgUrl" :href="item.imgUrl" target="_blank" class="banner-link"></a>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="newsList">
        <div class="new flex" style="margin-top: 0;">
          <a class="flex" style="cursor: pointer" href="/consult">
            <img src="/static/imgs/a.png" alt="" width="51">
            <div>
              <h3>我要咨询</h3>
              <p>心理咨询</p>
            </div>
          </a>
          <a class="flex" style="cursor: pointer" href="/exam">
            <img src="/static/imgs/b.png" alt="" width="51">
            <div>
              <h3>心理测试</h3>
              <p>心理测试</p>
            </div>
          </a>
        </div>
        <div class="list">
          <div class="flex title">
            <div class="flex">
              <h1>新闻资讯</h1><img src="../../assets/img/more.png" alt="" width="41">
            </div>
            <a href="/news" class="more newMore flex">查看更多>></a>
          </div>
          <div class="newsD">
            <div class="detail" v-for="(item,index) in news" :key="index">
              <router-link :to="'/newsDetail?id='+item.id">
                <div v-if="item.showDate" class="time flex" style="justify-content: inherit"><span
                    class="line"></span><span class="dot"></span><span
                    class="dot"></span>{{ item.publishDate | dateFmt('MM.dd') }}
                </div>
                <h3 class="tit">{{ item.title }}</h3>
                <p class="content">{{ item.summary }}</p>
                <p class="view flex">
                  <a href="javascript:void(0);" class="more">了解详情</a>
                  <span class="el-icon-view">{{ item.viewsCount }}</span>
                </p>
              </router-link>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    用户平台-->
    <!--        <div class="userPlatform">
              <div class="userCon">
                <div class="flex title">
                  <h1>用户平台</h1><img src="../assets/img/more.png" alt="" width="41">
                </div>
                <div class="platform flex">
                  <div v-for="item in platform" class="list" :key="item.id">
                    <span class="altImg doubtIMG"><img :src="item.img" alt="" width="100%"></span>
                    <span class="blue">{{ item.tit }}</span>
                    <p class="desc">{{ item.desc }}</p>
                  </div>
                  <div class="list cursor" @click="$router.push({path:'/userPlatform'})">
                    <span class="altImg "><img src="../assets/img/platfoormDoubt.png" alt="" width="100%"></span>
                    <span class="blue" >点击了解更多</span>
                    <p class="desc">进一步了解心理亦笙 能为您解决什么</p>
                  </div>
                </div>
                <div class="type">
                  <el-carousel height="180px" arrow="never" class="types" :interval="6000">
                    <el-carousel-item class="typeList flex" v-for="(obj,i) in serverTypes.slice(0, 5)" :key="i">
                      <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="itemIcon img"></div>
                      <div class="typeRight">
                        <h3 class="tit"> {{ obj.cnName }}</h3>
                        <p class="briefDesc">{{ obj.briefDesc }}</p>
                        <a :href="'/serviceType?id='+obj.id">了解详情>></a>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <div class="submitBtn">
                  <el-button plain @click="$router.push({path:'/helpCenter'})">如何预约咨询</el-button>
                  <el-button @click="toRegistered">注册心理亦笙用户</el-button>
                </div>
                <div style="clear:both;"></div>
              </div>
            </div>-->

    <!--    遇到问题-->
    <div class="problem">
      <div class="userCon">
        <div class="flex title">
          <h1>当你在日常生活中遇到这些问题，欢迎来到心理亦笙！</h1>
        </div>
        <div class="problemList flex">
          <div v-for="obj in systemArticleDictList" class="problemItem img" :key="obj.id"
               :style="'backgroundImage: url('+obj.itemIcon+')'">
            <span class="tit">{{ obj.itemName }}<i class="el-icon-caret-right"></i></span>
            <div class="details" @click="$router.push({path: '/systemArticle', query: {itemId: obj.id}})">
              <div class="flex-del">
                <h3>{{ obj.itemName }}</h3>
                <p class="desc">{{ obj.itemDesc }}</p>
                <router-link :to="{path: '/systemArticle', query: {itemId: obj.id}}">点击了解更多>></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    用户疑惑-->
    <div class="doubt">
      <div class="userCon">
        <div class="flex title">
          <h1>用户疑惑</h1><img src="../../assets/img/more.png" alt="" width="41">
        </div>
        <div class="flex doubtPro">
          <el-collapse class="left" v-model="active" accordion>
            <el-collapse-item
                class="problemOptions" v-for="(item,index) in problemOptions"
                :key="index" :name="index">
              <template slot="title"><h3 class="flex"><i class="icon">Q</i>{{ item.itemName }}</h3></template>
              <p class="answer">
                <span class=" icon">A</span>
                <span class="itemDesc">{{ item.itemDesc }}</span>
              </p>
            </el-collapse-item>
            <router-link to="/doubt">查看更多疑惑>></router-link>
          </el-collapse>
          <div class="right">
            <a class="helpList flex" v-for="(item , index) in helpList" :key="index"
               :href="'/helpCenter?smallTit='+item.smallTit">
              <div class="img headImgPath" :style="'backgroundImage: url('+item.headImgPath+')'"></div>
              <div class="desc">
                <span>{{ item.tit }} >></span>
                <p>{{ item.desc }}</p>
              </div>
            </a>
            <el-button @click="toRegistered">注册心理亦笙用户</el-button>
          </div>
        </div>
      </div>
    </div>

    <!--    用户反馈-->
    <div class="feedback" v-if="feedback.length > 0">
      <div class="userCon">
        <div class="flex title">
          <h1>用户反馈</h1><img src="../../assets/img/more.png" alt="" width="41">
        </div>
        <div class="back">
          <swiper ref="drugSwiper" class="deedbackList" :options="feedbackSwiperOptions">
            <swiper-slide v-for="item in feedback" :key="item.id">
              <div class="leftBack">
                <div class="desc">
                  <img src="../../assets/img/marks.png" alt="" width="32">
                  <p>{{ item.content }}</p>
                </div>
                <div class="userImg">
                  <div class="img" :style="'backgroundImage: url('+feedbackHead(item)+')'"></div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>

    <!--   人员-->
    <div class="user">
      <div class="userCon flex" style="justify-content: space-between">
        <div class="leftCon">
          <div class="flex title">
            <h1>专家团队</h1><img src="../../assets/img/more.png" alt="" width="41">
          </div>
          <div class="userList flex">
            <div :style="'backgroundImage: url('+main.headImgPath+')'" class="mainImg"
                 @click="toHomePage(main.account)"></div>
            <!--<img :src="main.headImgPath" alt="" width="337">-->
            <div class="userListFor" style="height: 371px;overflow: hidden;">
              <template v-for="(obj) in itemList">
                <div class="swiperImg flex" :key="obj.id" @click="toHomePage(obj.account)">
                  <div :style="'backgroundImage: url('+obj.headImgPath+')'" class="img"></div>
                  <div class="ri">
                    <strong>{{ obj.fullName }} {{ obj.enName }}</strong>
                    <p>咨询专长：{{ obj.indications | indicationFmt }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="userInfo">
            <h2>{{ main.fullName }} {{ main.enName }}</h2>
            <p v-if="main.supplement.signature" class="motto" slot="reference">“{{ main.supplement.signature }}”</p>
            <p slot="reference"><strong>咨询专长：</strong>{{ main.indications | indicationFmt }}</p>
            <p><strong>教育背景：</strong>{{ main.supplement.eduBackground }}</p>
            <p><strong>资质认证：</strong>{{ main.supplement.certSource }}</p>
            <p><strong>目前任职：</strong>{{ main.company }}{{ main.department }}{{ main.job }}</p>
            <div class="btnGroup">
              <el-button class="scale02" @click="toConsultation(main.account)">我要咨询</el-button>
              <el-button class="scale02" @click="toHomePage(main.account)">医生主页</el-button>
              <el-button class="scale02" @click="toDoctorPage">查看更多医生</el-button>
            </div>
          </div>
        </div>
        <!--        医生+咨询师-->
        <div class="newHelp">
          <h2 class="tit">医生+咨询师</h2>
          <div class="doctorRes">
            <div class="doctorResList" v-for="(item , index) in doctorRes" :key="index">
              <img :src="item.headImgPath" alt="" width="83">
              <div class="desc">
                <span>{{ item.tit }}</span>
                <p>{{ item.desc }}</p>
              </div>
            </div>
            <div class="doctorResList" style="cursor: pointer" @click="$router.push({path:'/doctorRegisterHelp'})">
              <img src="../../assets/img/doc_e.png" alt="" width="83">
              <div class="desc">
                <span>如何注册成为平台的心理医生或咨询师>></span>
                <p>注册完成用户才能对您进行预约咨询</p>
              </div>
            </div>
            <div class="doctorResList" style="cursor: pointer" @click="$router.push({path:'/doctorAppointHelp'})">
              <img src="../../assets/img/doc_f.png" alt="" width="83">
              <div class="desc">
                <span>如何设置预约，如何去咨询>></span>
                <p>用户在开放时间内进行预约，您需在 约定时间内完成咨询</p>
              </div>
            </div>
          </div>
          <el-button @click="$router.push({name: 'registered', params: {user: '2'}})">注册成为平台的心理医生或咨询师</el-button>
        </div>
      </div>
    </div>

    <!--        注册医生+咨询师-->
    <div class="medicine" style="background: rgba(246, 248, 255, 0.5)">
      <div class="userCon">
        <div class="flex title">
          <h1>最新注册医生+咨询师</h1><img src="../../assets/img/more.png" alt="" width="41">
        </div>
        <div class="userSwiperOptions">
          <swiper ref="drugSwiper" :options="userSwiperOptions">
            <swiper-slide v-for="item  in teamDoctorList" :key="item.id">
              <div class="consultantList" @click="toHomePage(item.account)">
                <div v-if="item.headImgPath" :style="{backgroundImage: 'url('+item.headImgPath+')'}" class="img"></div>
                <div class="img default-headImg" v-else :gender="item.gender"></div>
                <h4 class="enName">{{ item.fullName }}</h4>
                <h5 class="enName">{{ item.enName ? item.enName : '' }}</h5>
                <p class="enName">{{ item.company }}{{ item.technicalTitle }}</p>
              </div>
            </swiper-slide>
            <!-- 如果需要导航按钮 -->
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>

      </div>
    </div>

    <!--        学术研究-->
    <div class="academic">
      <div class="userCon">
        <div class="flex title">
          <h1>每日研究</h1><img src="../../assets/img/more.png" alt="" width="41">
        </div>
        <div class="flex ach">
          <div v-for="(item,index) in researches.slice(0,3)" :key="index" class="academicList">
            <router-link :to="'/studyDetail?id='+item.id">
              <div :style="'backgroundImage: url('+item.thumbnailPath+')'" class="img"></div>
              <h4>{{ item.title }}</h4>
              <p>{{ item.summary }}</p>
              <div href="javascript:void(0);" class="flex" style="justify-content: space-between;margin-top: 20px">
                <span class="el-icon-view">{{ item.viewsCount }}</span>
                <div class="flex">READ MORE
                  <div class="readMore"></div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="historyAch">
            <div class="historyResech">
              <router-link :to="'/studyDetail?id='+item.id" v-for="(item,index) in researches.slice(3,7)"
                           :key="index" class="list">
                {{ item.title }}
              </router-link>
            </div>
            <a href="/study" class="moreLibrary">
              <img src="../../assets/img/library_a.png" alt="" width="13">
              研究文库
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--        专业新药-->
    <div class="medicine">
      <div class="userCon">
        <div class="flex title">
          <h1>专业新药</h1><img src="../../assets/img/more.png" alt="" width="41">
        </div>
        <div class="flex ach">
          <div class="drug-block-left">
            <div class="item drug-thumbnail">
              <swiper ref="drugSwiper" :options="drugSwiperOptions">
                <swiper-slide v-for="drug in drugs_left" :key="drug.id">
                  <img class="drug-img" :src="drug.thumbnailPath">
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <div class="item brief-desc">
              <h3 style="margin-bottom: 20px">
                <span style="margin-right: 20px;">{{ curDrugSlide.cnName }}</span>
                <span>{{ curDrugSlide.enName }}</span>
              </h3>
              <p>{{ curDrugSlide.briefDesc }}</p>
            </div>
          </div>
          <div class="historyAch">
            <div class="historyResech">
              <router-link to="/medication" v-for="(item,index) in drugs_right"
                           :key="index" class="list">
                {{ item.cnName }}
              </router-link>
            </div>
            <a href="/medication" class="moreLibrary">
              <img src="../../assets/img/library_b.png" alt="" width="13">
              精神学药库
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--   专家会议-->
    <div class="consultation">
      <div class="userCon ">
        <div class="communicate">
          <div class="flex title"><h1>专家会议</h1><span class="dot"></span><span class="dot"></span><span
              class="line"></span></div>
          <h4>{{ consultation.title }}</h4>
          <div class="programList">
            <span>{{ consultation.subTitle }}</span>
          </div>
          <div class="btn">
            <el-button>期待您的加入</el-button>
            <el-button><a href="/consultation">查看更多</a></el-button>
          </div>
        </div>
        <div class="lecture">
          <div class="flex title"><h1>专家讲座</h1><span class="dot"></span><span class="dot"></span><span
              class="line"></span></div>
          <h2>{{ lecture.title }}</h2>
          <div class="programList">
            <p>
              <span class="beforeLine"></span>{{ lecture.subTitle }}
            </p>
          </div>
          <div class="btn">
            <el-button>期待您的加入</el-button>
            <el-button><a href="/lecture">查看更多</a></el-button>
          </div>
        </div>
        <div class="mask"></div>
        <div style="clear: both"></div>
      </div>
      <div class="bgT"></div>
      <div class="bgO"></div>
    </div>

    <!--    尾部-->
    <div class="introduce">
      <div class="news">
        <div class="ysh">
          <img src="../../assets/img/logoFotter.png" alt="">
          <p>吸纳中外的心理、精神和神经方面的专家学者参与，为中美欧华人及留学生提供专业的心理辅导与专业帮助！</p>
          <p>同时，这个平台也给中美业界同行们提供最新的学术研究新闻，为中国同行提供便利高效的精神学药库等其他方面的服务。</p>
          <p>欢迎您加盟我们团队，为用户服务！</p>
        </div>
        <div class="concact">
          <p class="tit">联系我们</p>
          <div class="concactInfo">
            <p>{{ concact.email }}</p>
            <p>{{ concact.tel }}</p>
          </div>
          <div class="showFeedbackDialog">
            <p class="tit">咨询反馈</p>
            <div class="inputFeed flex" @click="showFeedbackDialog()">
              <span>请留下您的咨询感受</span>
              <span>提交</span>
            </div>
          </div>

        </div>
        <div class="shortcutMenu">
          <p class="tit">快捷菜单</p>
          <div class="listMenu">
            <a v-for="(item,index) in shortcutMenu" :href="item.path" :key="index">{{ item.tit }}</a>
          </div>
        </div>
        <div class="peopleNum flex">
          <div>
            <h1>{{ statistics.doctors }}</h1>
            <span>注册医生</span>
          </div>
          <div>
            <h1>{{ statistics.users }}</h1>
            <span>注册用户</span>
          </div>
        </div>
        <div class="peopleNum flex">
          <div>
            <h1>{{ statistics.appoints }}</h1>
            <span>咨询次数</span>
          </div>
          <div>
            <h1>{{ statistics.visits }}</h1>
            <span>访问次数</span>
          </div>
        </div>
      </div>
    </div>

    <!--    悬浮框-->
    <suspensionDrawer></suspensionDrawer>

    <!--    登录-->
    <loginCommon ref="loginCommon"></loginCommon>

    <!--    用户反馈对话框 start-->
    <el-dialog top="0" :visible.sync="showAddFeedbackDialog" :close-on-click-modal="false"
               :show-close="false" width="500px" class=" updateMem" :close-on-press-escape="false">
      <template #title>
        <h1 class="tit">用户反馈</h1>
      </template>
      <el-form :model="addFeedbackData" class="rowsInfo" label-suffix="：" label-width="90px" :rules="addFeedbackRules"
               ref="addFeedbackForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addFeedbackData.title" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="addFeedbackData.contact" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="4" v-model="addFeedbackData.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFeedbackDialog()">取 消</el-button>
        <el-button type="primary" @click="addFeedback()">确 定</el-button>
      </div>
    </el-dialog>
    <!--    用户反馈对话框 end-->

    <!-- 登录弹窗 -->
    <loginDialog ref="loginDialog"></loginDialog>


  </div>
</template>

<script>
import commonjs from "@/api/common";

let doctorIntervalCount = 0;
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import base from '@/api/common';
import loginCommon from '../loginCommon'
import loginDialog from "@/components/loginDialog";
import suspensionDrawer from "@/components/suspensionDrawer";

require("swiper/dist/css/swiper.css");


export default {
  name: "index",
  data() {
    let that = this;
    return {
      newsBanner: [],// 新闻轮播图
      active_index: 0,//
      type: [],

      userSwiperOptions: {
        slidesPerView: 6,
        speed: 1000,
        loop: true,
        autoplay: 2000,
        autoplayDisableOnInteraction: true,
        loopedSlides: 5,
        loopAdditionalSlides: 3,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
      },
      interVal: {}, // banner 轮播间隔
      doctors: [],
      serverTypes: [],
      professionals: [],
      news: [],
      researches: [],

      drugs_left: [],
      drugs_right: [],

      consultation: {},
      lecture: {},


      curDrugSlide: {},
      drugSwiperOptions: {
        observer: true,
        observeSlideChildren: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: 3000,
        onSlideChangeStart: function (swiper) {
          that.curDrugSlide = that.drugs_left[swiper.activeIndex];
        }
      },
      /* introduce: '吸纳中国的神经、精神和心理方面的专家学者参与，为中美欧华人及留学生提供专业的心理辅导与专业帮助！\n' +
           '同时，这个平台也给美中业界同行们提供最新的学术研究新闻，为中国同行提供便利高效的精神学药库等其他方面的服务。\n' +
           '欢迎您加盟我们团队，为患者服务！',*/
      concact: {
        email: 'service@yshinfo.com',
        tel: '0755-28291983'
      },
      shortcutMenu: [
        {tit: '我要咨询', path: '/consult'},
        {tit: '专业医生', path: '/famousDoctor'},
        {tit: '每日研究', path: '/study'},
        {tit: '专业用药', path: '/medication'}, // TODO
        {tit: '新闻资讯', path: '/news'},
        {tit: '专家会议', path: '/consultation'}
      ],
      statistics: {
        doctors: 126,
        appoints: 1653,
        users: 3692,
        visits: 7655
      },
      teamDoctorList: [],
      // 用户反馈
      feedback: [],
      feedbackSwiperOptions: {
        observer: true,
        observeSlideChildren: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: false,
      },

      // 用户疑惑
      problem: '',
      problemOptions: [],
      proAnswer: '',
      active: 0,
      disabled: false,
      nextDisabled: false,
      // 可提供
      helpList: [],
      showAddFeedbackDialog: false, //展示用户反馈对话框
      addFeedbackData: {//添加用户反馈的数据
        title: null,//标题
        content: null,//内容
        contact: null,//联系方式
      },
      addFeedbackRules: {//用户反馈校验
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入反馈内容', trigger: 'blur'},
        ],
        contact: [
          {max: 255, message: '长度最长为255', trigger: 'blur'}
        ],
      },
      // 用户平台
      platform: [],
      typesSwiperOptions: {
        observer: true,
        observeSlideChildren: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: false,
      },
      // 医生+咨询师
      doctorRes: [],
      // 悬浮框
      show: true,
      suspension: true,
      userType: '',
      //系统文章dict
      systemArticleDictList: [],
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    loginCommon,
    loginDialog,
    suspensionDrawer
  },
  computed: {
    swiper() {
      return this.$refs.drugSwiper.$swiper
    },
    main() {// 人员-显示大图
      return this.doctors[0] || {supplement: {}}
    },
    itemList() {// 人员-右边小图
      let arr = this.doctors || [];
      return arr.filter((item, index, arr) => {
        if (index != 0) {
          return item
        }
      })
    }
  },
  beforeCreate() {
    if (base.utils.isMobileWeb() || base.utils.isWechatClient()) {
      location.href = base.h5_url;
      return;
    }
  },
  mounted() {

    if (localStorage.user_type && localStorage.user_type == 2) {
      this.userType = 'doctor';
    } else if (localStorage.user_type == 1) {
      this.userType = 'user';
    }
    // 帮助中心
    this.getFeedback()
    // 新闻
    this.$ajax.get(base.api.recommend.news).then((res) => {
      if (res.data.status === 'success') {
        let dateMap = new Map();
        $(res.data.list).each((i, o) => {
          o.showDate = true;
          let dateKey = new Date(o.publishDate).Format('yyyy-MM-dd');
          let mapEle = dateMap.get(dateKey);
          if (mapEle) { // 时间存在重复值
            o.showDate = false;
          } else {
            dateMap.set(dateKey, true);
          }
        });
        // 赋值新对象
        this.news = res.data.list;
      }
    });

    // 医生: 推荐设置 ==> 团队随机获取(21.01.29)
    this.$ajax.get(base.api.recommend.doctor).then((res) => {
      if (res.data.status === 'success') {
        let doctors = res.data.list;

        let fixedList = [], otherList = [];
        $(doctors).each((i, d) => {
          if (!d.supplement) {
            d.supplement = {};
          }
          if (d.isFixed) {
            fixedList.push(d);
          } else {
            otherList.push(d);
          }
        });
        // 打乱顺序
        otherList.sort(function () {
          return 0.5 - Math.random();
        });

        if (fixedList.length > 4) {
          this.doctors = fixedList.slice(0, 4);
        } else {
          this.doctors.push(...fixedList);
          let subNum = 4 - fixedList.length;
          this.doctors.push(...(otherList.slice(0, subNum)));
        }

        let vm = this;
        let intervalPeriod = 8; // 秒
        this.interval = setInterval(() => {
          doctorIntervalCount++;
          if (doctorIntervalCount % intervalPeriod == 0) { //一周期
            vm.doctors.length = 0;
            otherList.sort(function () {
              return 0.5 - Math.random();
            });
            if (fixedList.length > 4) {
              vm.doctors = fixedList.slice(0, 4);
            } else {
              vm.doctors.push(...fixedList);
              let subNum = 4 - fixedList.length;
              vm.doctors.push(...(otherList.slice(0, subNum)));
            }
          } else { //循环
            vm.doctors.push(vm.doctors.shift(1));
          }
        }, intervalPeriod * 1000);
      }
    });

    // 侧边type
    this.$ajax.get(base.api.indication.types.all).then((res) => {
      if (res.data.status === 'success') {
        this.serverTypes = res.data.list;
      }
    });
    // 科室
    this.$ajax.get(base.api.dict.professional_department + '?size=5').then(res => {
      if (res.data.status === 'success') {
        this.professionals = res.data.list;
      }
    });

    // 学术研究
    // 1. 先加载类型默认信息
    this.$ajax.get(base.api.dict.article.research).then(res => {
      if (res.data.status === 'success') {
        let typeMap = new Map();
        $(res.data.list).each((i, o) => {
          typeMap.set(o.id, o);
        });
        // 2. 加载研究信息
        this.$ajax.get(base.api.recommend.research).then((res) => {
          if (res.data.status === 'success') {
            $(res.data.list).each((i, o1) => {
              if (!o1.thumbnailPath) {
                o1.thumbnailPath = typeMap.get(o1.pageType).itemIcon;
              }
            });
            this.researches = res.data.list;
          }
        });
      }
    });

    // 药
    this.$ajax.get(base.api.recommend.drug_fresh).then(res => {
      if (res.data.status === 'success') {
        let length = res.data.list.length;
        if (length <= 3) {
          this.drugs_left = res.data.list;
          this.drugs_right = res.data.list;
        } else if (length <= 7) {
          this.drugs_left = res.data.list.slice(0, 3);
          this.drugs_right = res.data.list.slice(3, length);
        } else {
          this.drugs_left = res.data.list.slice(0, length - 4);
          this.drugs_right = res.data.list.slice(length - 4, length);
        }
        this.curDrugSlide = this.drugs_left[0];
      }
    });

    // 会诊
    this.$ajax.get(base.api.recommend.consultation).then((res) => {
      if (res.data.status === 'success') {
        this.consultation = res.data.data;
      }
    });
    // 讲座
    this.$ajax.get(base.api.recommend.lecture).then((res) => {
      if (res.data.status === 'success') {
        this.lecture = res.data.data;
      }
    });
    // banner
    this.$ajax.get(base.api.banner.index.list).then((res) => {
      if (res.data.status === 'success') {
        this.newsBanner = res.data.list
      }
    });

    // 统计
    this.$ajax.get(base.basePath + 'auth/auth-doctor/statistics').then(res => {
      if (res.data.status === 'success') {
        this.statistics.doctors = res.data.doctors;
        this.statistics.appoints = res.data.appoints;
      }
    });
    this.$ajax.get(base.basePath + 'auth/auth-user/statistics').then(res => {
      if (res.data.status === 'success') {
        this.statistics.users = res.data.users;
      }
    });
    this.$ajax.get(base.basePath + 'communication/comm-visit-history/visits/count').then(res => {
      if (res.data.status === 'success') {
        this.statistics.visits = res.data.data;
      }
    })
// 注册医生+咨询师
    let condition = {
      current: 1,
      size: 15,
      orderByNewest: 1
    };
    this.$ajax.post(base.api.doctor.condition, condition).then(res => {
      if (res.data.status === 'success') {
        this.teamDoctorList = res.data.rows;
      }
    });

    //获取用户疑惑
    this.$ajax.get(base.api.dict.userQA).then((res) => {
      if (res.data.status === 'success') {
        this.problemOptions = res.data.list.slice(0, 5);
        /*  this.problem = this.problemOptions[this.active].itemName
          this.proAnswer = this.problemOptions[this.active].itemDesc
          if (this.active === 0) {
            this.disabled = true
          }*/
      }
    })
    $(".contentIndex").animate({scrollTop: '0px'}, 800);


    //获得用户反馈
    this.$ajax.get(base.api.feedback.list).then((res) => {
      if (res.data.status === 'success') {
        this.feedback = res.data.list
      }
    })
    // 获得系统文章dict
    this.getSystemArticleDict();
  },
  methods: {
    toHelp(item) {
      this.$router.push({path: '/helpCenter', query: {smallTit: item.smallTit}})
    },
    // 帮助中心
    getFeedback() {
      this.$ajax.get("./ordinary.json").then((res) => {
        // this.feedback = res.data.feedback
        this.helpList = res.data.helpList
        this.platform = res.data.platform
        this.doctorRes = res.data.doctorRes
      })
    },
    // 获取问题
    /*    getordinary() {
          this.problem = this.problemOptions[this.active].itemName
          this.proAnswer = this.problemOptions[this.active].itemDesc
          if (this.active === 0) {
            this.disabled = true
          }
        },*/
    // 切换用户疑惑问题
    /* change(item) {
       this.active = item.sort - 1;
       /!*      console.log(this.active)
             console.log(this.problemOptions.length - 1)*!/
       if (this.active === 0) {
         this.disabled = true
       } else if (this.active === this.problemOptions.length - 1) {
         this.nextDisabled = true
       } else {
         this.disabled = false
         this.nextDisabled = false
       }
       this.proAnswer = item.itemDesc
     },
     prev() {
       this.active--;
       this.getordinary()
       this.nextDisabled = false
     },
     next() {
       this.active++;
       this.disabled = false
       this.getordinary()
       if (this.active === this.problemOptions.length - 1) {
         this.nextDisabled = true
       }
     },*/

    toConsultation(account) {//我要咨询
      this.$router.push({path: '/consult'})
    },
    toHomePage(account) {//医生主页
      this.$router.push({path: '/' + account})
    },
    toDoctorPage() {
      //this.$parent.$refs.headerRef.active = 3;
      this.$router.push({name: 'famousDoctor'});
    },
    toRegistered() {
      this.$router.push({name: "registered", params: {user: "3"}});
    },
    //添加用户反馈
    addFeedback() {
      this.$refs['addFeedbackForm'].validate((valid) => {
        if (valid) {
          let that = this;
          this.$ajax.post(base.api.feedback.add, this.addFeedbackData).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success('提交成功');
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error("操作异常");
          }).finally(() => {
            that.closeFeedbackDialog();
          })
        } else {
          this.$message.error("请检查数据");
          return false;
        }
      });
    },
    closeFeedbackDialog() {
      this.addFeedbackData = {
        title: null,
        content: null,
        contact: null,
      };
      this.showAddFeedbackDialog = false;
    },
    async showFeedbackDialog() {
      let that = this;
      let user = await base.utils.getCurrent();
      if (user == null) {
        that.$refs.loginDialog.dialogVisible = true;
        that.$refs.loginDialog.reloadCode('vcode-user');
        that.$refs.loginDialog.successUrl = '/index';
      } else {
        this.showAddFeedbackDialog = true;
      }
    },

    //获取系统文章的标签
    getSystemArticleDict() {
      let that = this;
      this.$ajax.get(base.api.dict.article.system.itemList).then((res) => {
        if (res.data.status === 'success') {
          that.systemArticleDictList = res.data.list;
        }
      })
    },
    feedbackHead(obj) {
      if (obj.headImgPath) {
        return obj.headImgPath
      } else {
        if (obj.gender === 1) {
          return '/static/imgs/feedback_man.png'
        } else if (obj.gender === 0) {
          return '/static/imgs/feedback_woman.png'
        } else {
          return '/static/imgs/feedback_man.png'
        }
      }
    }
  },
  filters: {
    indicationFmt(indications) {
      if (indications) {
        let skills = [];
        $(indications).each((i, o) => {
          if (o && o.cnName) {
            skills.push(o.cnName);
          }
        });
        return skills.join("、");
      }
    },
    dateFmt(date, pattern) {
      if (date) {
        if (!pattern) {
          pattern = "yyyy-MM-dd";
        }
        return new Date((date.toString().replace(/-/g, "/"))).Format(pattern);
      }
    }
  },

}
</script>
<style scoped lang="scss">
@import '../../assets/css/index_a';
a.banner-link{
  display: block;
  width: 100%;
  height: 100%;
}
</style>
